import { render, staticRenderFns } from "./index.vue?vue&type=template&id=281f2bf8&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=281f2bf8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281f2bf8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('281f2bf8')) {
      api.createRecord('281f2bf8', component.options)
    } else {
      api.reload('281f2bf8', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=281f2bf8&scoped=true&", function () {
      api.rerender('281f2bf8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/bind/index.vue"
export default component.exports